import * as yup from "yup";

export const newProviderValidationSchema = yup.object().shape({
  providerContactDetails: yup.object().nullable(),
  locationType: yup
    .string()
    .oneOf(
      ["primary", "secondary", "other"],
      "You must select a location type."
    )
    .required("This field is required"),
  primaryLocationTextBox: yup.string().required("Primary Location is required"),
  primaryLocation: yup.string(),
  addtionalAddresses: yup.string(),
  secondaryLocationTextBox: yup.string(),
  otheryLocationTextBox: yup.string(),
  secondaryAddress: yup.string().notRequired(),
  serviceCategories: yup
    .array()
    .min(1, "Please select at least one service category.")
    .required(),
  draftDate: yup
    .object({
      startDate: yup
        .date()
        .required("Desired Initial Draft Date is required")
        .test(
          "is-valid-date",
          "Start date must be a valid date",
          (value) => !isNaN(new Date(value).getTime())
        ),
    })
    .required("Draft date is required"),
  additionalDetails: yup.string().notRequired(),
  multiSponsor: yup.boolean().notRequired(),
  providerName: yup.string().required("Vendor name is required"),
  mainContactName: yup.string().required("Main contact name is required"),
  mainContactEmail: yup
    .string()
    .email()
    .required("Main contact email is required"),
  country: yup.object().nullable(),
  providerUrl: yup
    .string()
    .test(
      "is-https",
      "Only HTTPS URLs are accepted for security compliance.",
      (value) => {
        if (!value || typeof value !== "string" || !value.trim()) return true;
        const v = value.trim().toLowerCase();
        if (v.startsWith("http://")) return false;
        if (v.startsWith("https://")) return true;
        try {
          new URL("https://" + value);
          return true;
        } catch {
          return false;
        }
      }
    ),
  streetAddress: yup.string(),
  city: yup.string(),
  state: yup.string(),
  zipCode: yup.string(),
  additionalAddress: yup.string(),
  onsiteRemote: yup
    .object()
    .shape({
      onsite: yup.boolean().required("Onsite is required."),
      remote: yup.boolean().required("Remote is required."),
    })
    .test(
      "only-one-true",
      "Only one option (onsite or remote) must be selected.",
      (value) => {
        const values = Object.values(value || {});
        return values.filter((v) => v === true).length === 1;
      }
    )
    .required("This field is required"),
});
